import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../base/services/betslip-messages-provider.service';
import {
    IPlaceButtonStateService,
    PLACE_BUTTON_STATE_SERVICE,
} from '../../../betplacement/services/place-button/viewmodel/interfaces/place-button-interfaces';
import DigitalSettingsActions from '../../../settings/digital-actions';
import BetslipPickActions from '../../actions';

@Component({
    selector: 'bs-digital-picks-linear-toolbar',
    templateUrl: './picks-toolbar-linear.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./picks-toolbar-linear.component.scss'],
    standalone: false,
})
export default class PicksToolbarLinearComponent {
    readonly messages: {
        clearAllMessage: string;
    };

    readonly showToolbarActions: Signal<boolean>;

    @HostBinding('class') className = 'betslip-picks-toolbar';

    constructor(
        private store: Store,
        private changeDetector: ChangeDetectorRef,
        private trackingService: TrackingService,
        @Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageLinearProvider: ILinearBetslipMessagesProviderService,
        @Inject(PLACE_BUTTON_STATE_SERVICE) private placeButtonService: IPlaceButtonStateService,
    ) {
        const confirmationMessages = messageLinearProvider.getMessages().linear;
        this.messages = {
            clearAllMessage: confirmationMessages.ClearAllConfirmation,
        };

        const showToolbarActions$ = this.placeButtonService.state$.pipe(
            takeUntilDestroyed(),
            map((state) => !state.isProcessing),
        );

        this.showToolbarActions = toSignal(showToolbarActions$, { initialValue: true });
    }

    requestRemoveAllPicks(): void {
        this.trackActions('delete all', NOT_APPLICABLE);
        this.changeDetector.markForCheck();
        this.store.dispatch(BetslipPickActions.requestRemoveAllPicks());
    }

    openSettingsDialog(): void {
        this.store.dispatch(DigitalSettingsActions.openSettings());
    }

    private trackActions(labelEvent: string, eventDetails: string) {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betslip',
            [trackingConstants.COMPONENT_LABEL_EVENT]: labelEvent,
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }
}
